import dayjs from 'dayjs'

import 'dayjs/locale/de'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

dayjs.locale('de')

dayjs.tz.setDefault('Europe/Berlin')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
